<template>
  <component
    ref="dynamicComp"
    :is="componentLoader"
    :comp="comp"
    @on-show-task="$emit('on-show-task', $event)"
    @on-course-info="$emit('on-course-info', $event)"
  ></component>
</template>

<script>
export default {
  name: "taskBox",
  props: {
    src: {
      type: String,
      default: () => null
    },
    comp: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    if (this.$props.src) {
      this.loadComponent();
    }
  },
  computed: {
    componentLoader() {
      return () => import(`@/views/shuffle/components/${this.src}.vue`);
    }
  },
  methods: {
    loadComponent() {
      this.componentLoader().then(() => {});
    }
  }
};
</script>
